export const INTERVAL_TIME = 5000;
export const MAX_REMOTE_ACTIONS_RETRY_COUNT = 3;
export const DEFAULT_IDLE_TIME = 60000;
